"use client";

import { Command } from "cmdk";

interface GroupProps {
	children: React.ReactNode;
	heading?: string;
}

export function CommandGroup({ children, heading }: GroupProps) {
	return (
		<Command.Group
			className="child:mb-1 mb-4 text-shades-dark text-sm last:child:mb-0 last:mb-0"
			heading={heading}
		>
			{children}
		</Command.Group>
	);
}
